import React, { Fragment } from 'react'
import moment from 'moment'
import numeral from 'numeral'
import FontAwesome from 'react-fontawesome'

import {
    formatcoin
} from '../../utils/helpers'

export const RowDocumentosAsociados = ({ origen, documento, indice, enums, downloadFile, divisa }) => {
    let valor = 0;
    let fecha_inicio = null
    let fecha_entrega = null
    let adjunto = null

    if (documento.get('tipo') == 6) {
        const totalSevicios = origen.get('detalles').reduce((a, b) => {
            if (!b.get('adicion_id')) a += (b.get('valor') * b.get('cantidad'))
            return a
        }, 0)
        //valor = Math.round((totalSevicios * (origen.get('anticipo'))) / 100)
        valor = (totalSevicios * (origen.get('anticipo'))) / 100
        fecha_entrega = moment(origen.get('pago_anticipo')).format('YYYY-MM-DD')
    } else {
        valor = documento.get('detalles').reduce((a1, b1) => { a1 += b1.get('valor_con_iva'); return a1 }, 0)
        fecha_inicio = documento.get('fecha_inicio') ? moment(documento.get('fecha_inicio')).format('YYYY-MM-DD') : null
        fecha_entrega = documento.get('fecha_entrega') ? moment(documento.get('fecha_entrega')).format('YYYY-MM-DD') : null
    }

    if (documento.get('adjuntos').count() > 0) {
        adjunto = documento.getIn(['adjuntos', -1])
    }

    return (
        <Fragment>
            <tr>
                <td>{documento.get('consecutivo') ? enums.documentos.tipos[documento.get('tipo')].PREFIJO + documento.get('consecutivo') : ''}</td>
                <td>{documento.getIn(['proveedore', 'nombre'])}</td>
                <td style={{ textAlign: 'right' }}>{ formatcoin(valor,divisa.simbolo) }</td>
                <td>{enums.documentos.tipos[documento.get('tipo')] ? enums.documentos.tipos[documento.get('tipo')].NOMBRE : null}</td>
                <td>{enums.documentos.estados[documento.get('estado')]}</td>
                <td style={{ textAlign: 'right' }}>{fecha_inicio}</td>
                <td style={{ textAlign: 'right' }}>{fecha_entrega}</td>
                <td style={{ padding: '0' }}>
                    <table className="table table-condensed table-striped">
                        <tbody>
                            {
                                documento.get('detalles').map((c, d) => {
                                    return (
                                        <tr key={`tr5[${documento.get('id')}][${c.get('id')}]`}>
                                            <td className={c.get('adicion_id') !== null ? 'adicional' : ''}>{c.get('descripcion')}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </td>
                <td style={{ textAlign: 'center' }}>
                    {
                        adjunto && <FontAwesome key={`font1[${adjunto.get('id')}]`} name="download"
                            onClick={e => downloadFile(adjunto.get('id'), adjunto.get('nombre'))} />
                    }
                </td>
            </tr>
            {
                documento.get('tipo') === 4 && documento.get('documentos').count() > 0 ?
                    documento.get('documentos').map((sub, idx) =>
                    <RowDocumentosAsociados origen={documento} documento={sub} indice={indice + idx} key={`tr4[${sub.get('id')}]`}
                        downloadFile={downloadFile} enums={enums} />) : null
            }
        </Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/components/Documentos/RowDocumentosAsociados.jsx